// extracted by css-extract-rspack-plugin
export default {"linkButton":"vkCpnFqJ59orUUyZ"};